@if (i18n.translations$ | async; as translations) {
<div class="success-sector">
    <h1 class="success-title">{{ i18n.t(translations, 'success.title') }}</h1>
    <p class="success-paragraph">{{ i18n.t(translations, 'confirmation.emailSent') }}</p>
    <p class="arrival-time">{{ i18n.t(translations, 'success.arrivalTime') }}</p>
    <button class="btn-primary" type="button" (click)="goToLogin()">
        {{ i18n.t(translations, 'success.startBrowsing') }}
    </button>
</div>
}